import { render } from "./Politiques.vue?vue&type=template&id=5e11b6ea"
import script from "./Politiques.vue?vue&type=script&lang=js"
export * from "./Politiques.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/benin/prod/landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__